/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { AppSkeletonImage } from '../../common/ui/AppSkeletonImage.tsx';
import accessImgSVG from './assets/project-settings-access-app-skeleton.tpl.svg';
import detailsImgSVG from './assets/project-settings-details-app-skeleton.tpl.svg';
import featuresImgSVG from './assets/project-settings-features-app-skeleton.tpl.svg';

const customCssStyles = css({
	marginTop: token('space.0'),
	marginRight: 'auto',
	marginBottom: token('space.0'),
	marginLeft: 'auto',
	maxWidth: '1024px',
	/* Fix FF 2x scale bug on high res devices https://bugzilla.mozilla.org/show_bug.cgi?id=986403 */
	'@media (min--moz-device-pixel-ratio: 2)': {
		maxWidth: '510px',
	},
});

const listOnlyStyles = css({
	// increase self specificity to ensure deterministic override
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		border: 'none',
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
		marginTop: '-110px',
	},
});

export const ProjectSettingsAccessSkeleton = () => (
	<AppSkeletonImage src={accessImgSVG} css={customCssStyles} />
);

export const ProjectSettingsDetailsSkeleton = ({
	isListOnly = false,
}: {
	isListOnly?: boolean;
}) => (
	<AppSkeletonImage src={detailsImgSVG} css={[isListOnly ? listOnlyStyles : customCssStyles]} />
);

export const ProjectSettingsFeaturesSkeleton = ({
	isListOnly = false,
}: {
	isListOnly?: boolean;
}) => (
	<AppSkeletonImage src={featuresImgSVG} css={[isListOnly ? listOnlyStyles : customCssStyles]} />
);
